import WebSocketConnectionStatus from '../../models/enums/websocket-connection-status';
import User, { UserData } from '../../models/general/user';
import HttpError from '@common/interfaces/api/http-error';
import HttpFetchStatus from '@common/enums/api/http-fetch-status';
import RestSet, { defaultRestSet } from '@common/interfaces/api/rest-set';
import { OrgUserRestSet } from '../../models/misc/api/rest-set';
import SearchResult from '../../models/misc/search-result';
import DeploymentWeeks from '../../models/organization/deployment-week';
import ListOrganization from '../../models/organization/list-organization';
import Organization from '../../models/organization/organization';
import ExternalApi from '../../models/organization/external-api';
import OrganizationDeleteData from '../../models/organization/organization-delete-data';
import ValidationResult from '@common/interfaces/api/validation-result';
import { defaultState } from '../general/general-slice-definitions';

export interface OrganizationRestSet extends RestSet {
  getAllOrganizationsStatus: HttpFetchStatus;
  getAllOrganizationsError: HttpError | null;
  getLocationSetStatus: HttpFetchStatus;
  getLocationSetError: HttpError | null;
  patchCostCalculationsStatus: HttpFetchStatus;
  patchCostCalculationsError: HttpError | ValidationResult[] | null;
  getDeploymentWeeksStatus: HttpFetchStatus;
  getDeploymentWeeksError: HttpError | null;
  getDeleteStatus: HttpFetchStatus;
  getDeleteError: HttpError | null;
}

interface OrganizationState {
  organizations: {
    current: Organization | null;
    sub: ListOrganization[] | null;
    locationSet: ListOrganization[] | null;
    deploymentWeeks: DeploymentWeeks[] | null;
    rest: OrganizationRestSet;
    deleteData: OrganizationDeleteData | null;
  };
  search: {
    data: SearchResult[];
    count: number;
    getStatus: HttpFetchStatus;
    getError: HttpError | null;
  };
  users: {
    data: User[] | null;
    current: User | null;
    currentUserAllData: UserData | null;
    rest: OrgUserRestSet;
  };
  selectedUserId: string | null;
  organizationHubStatus: WebSocketConnectionStatus;
  externalApi: { data: ExternalApi[] | null; created: ExternalApi | null; rest: RestSet };
}

export const defaultOrganizationsState = {
  current: null,
  sub: null,
  locationSet: null,
  deploymentWeeks: null,
  deleteData: null,
  rest: {
    ...defaultRestSet,
    getAllOrganizationsStatus: HttpFetchStatus.Idle,
    getAllOrganizationsError: null,
    getLocationSetStatus: HttpFetchStatus.Idle,
    getLocationSetError: null,
    patchCostCalculationsStatus: HttpFetchStatus.Idle,
    patchCostCalculationsError: null,
    getDeploymentWeeksStatus: HttpFetchStatus.Idle,
    getDeploymentWeeksError: null,
  } as OrganizationRestSet,
};

export const getInitialOrganizationState = (): OrganizationState => {
  return {
    organizations: defaultOrganizationsState,
    search: { data: [], count: 0, getStatus: HttpFetchStatus.Idle, getError: null },
    users: {
      ...defaultState,
      current: null,
      currentUserAllData: null,
      rest: {
        ...defaultRestSet,
        patchType: null,
        getByIdStatus: HttpFetchStatus.Idle,
        getByIdError: null,
        getAllUserDataByIdStatus: HttpFetchStatus.Idle,
        getAllUserDataByIdError: null,
      },
    },
    selectedUserId: null,
    organizationHubStatus: WebSocketConnectionStatus.DISCONNECTED,
    externalApi: { data: null, created: null, rest: defaultRestSet },
  };
};
export type { OrganizationState };
